<div class="property-description-page__grid-container">
    <h1 class="property-description-page__title">About your property</h1>
    <property-listing-title-section
        class="property-description-page__listing-title-section"
    >
    </property-listing-title-section>
    <property-about-section class="property-description-page__about-section">
    </property-about-section>
    <property-side-card
        class="property-description-page__side-card-section"
        [icon]="sideCardIcon"
        [heading]="sideCardHeading"
        [callToActionText]="sideCardCallToActionText"
        [callToActionLink]="sideCardCallToActionLink"
    >
        <div class="property-description-page__side-card-description">
            <p>What’s the neighbourhood like?</p>
            <p>Are there any renovations or outstanding features?</p>
            <p>How big are the bedrooms?</p>
            <p>What type of heating and insulation is installed?</p>
            <p>Is there a view from the property?</p>
        </div>
    </property-side-card>
    <property-sale-attribute-section
        class="property-description-page__attribute-section"
    >
    </property-sale-attribute-section>
</div>
